module.exports = __webpack_public_path__ + "assets/img/311e179006811310ae184a82b1aadfd9.png";